export const RAE_MLII_AMPL_THRES_MV = 0.25;
export const RAE_V1_V2_AMPL_THRES_MV = 0.15;
export const LAE_DUR_THRES_MS = 120;
export const IVCD130_QRS_DUR_THRES_MS = 130;
export const IVCD110_QRS_DUR_THRES_MS = 110;
export const SHORT_PR_DUR_THRES_MS = 120;
export const AVB1_BLOCK_PR_DUR_THRES_MS = 200;
export const LEFT_QRS_AXIS_THRES_DEG = {
  min: -90,
  max: -30,
};
export const RIGHT_QRS_AXIS_THRES_DEG = {
  min: 90,
  max: 180,
};
export const RIGHT_SUP_QRS_AXIS_THRES_DEG = {
  min: -180,
  max: -90,
};
export const SHORT_QTCB_DUR_THRES_MS = 340;
export const SIGNIFICANT_QTC_PROLONG_F_DUR_THRES_MS = 460;
export const SIGNIFICANT_QTC_PROLONG_M_DUR_THRES_MS = 450;
export const BORDERLINE_QTC_INTERVAL_F_DUR_THRES_MS = {
  min: 450,
  max: 460,
};
export const BORDERLINE_QTC_INTERVAL_M_DUR_THRES_MS = {
  min: 430,
  max: 450,
};
export const VENTRICULAR_PAUSE_RR_DUR_THRES_MS = 3000;
export const SEVERE_BRADYCARDIA_HR_DUR_THRES_MS = 30;
export const BRADYCARDIA_HR_DUR_THRES_MS = 60;
export const TACHYCARDIA_HR_DUR_THRES_MS = 100;
